import React from "react";
import { Component } from "react";
import { Switch } from "react-router-dom";
import FixedView from "../FixedView";
import FieldItem from "./FieldItem";
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import { getBoundingClientRect } from "../../utils/functions";
import LoaderButton from "../LoaderButton";
import { checkTranslation, translate } from "../../utils/useful";
import { nanoid } from "nanoid";
import SocketServices from "../../utils/socket.services";


class GroupedBy extends Component {
  state = {
    groupby: [],
    characters: [],
    search: "",
    default: [],
    test: {},
  };


  componentDidMount() {
    // console.log('didm3', this.props.view)
    this.init()
    this.setState({ groupby: this.props.headers }, () => {
      this.setState({ characters: this.state.groupby });
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.headers != this.props.headers) {
      this.init()
    }
    console.log('this.props.view.settingsO', this.props.view?.settings?.groupBy)
    if (JSON.stringify(prevProps.view?.settings) != JSON.stringify(this.props.view?.settings)) {
      // console.log('componentDidUpdate')
      this.init()
    }
  }
  init = () => {
    // console.log('init this.props', this.props)
    let defaultt = []
    if (this.props.view?.settings) {
      this.setState({ default: [] }, () => {
        // console.log('this.props.view.settings.groupBy', this.props.view.settings.groupBy)
        this.props.view.settings.groupBy?.forEach((element) => {
          console.log('groupbygroupby', element)
          this.props.headers.forEach((item) => {
            if (item.key == element) {
              defaultt.push(item)
            }
          })
        })
        // console.log('defaultt', defaultt)
        // this.makeList()
        this.setState({ default: defaultt })
      })
    }
  }
  onDragEnd = (result) => {
    // console.log("hello", result);
    let items = Array.from(this.state.default);
    let [reorderItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderItem);
    this.setState({ default: items }, () => {
      this.makeList()
    });
  };
  openSortView = () => {
    this.sortView.showView();
  };

  openDateView = () => {
    this.dateView.showView();
  };

  searchInput = (e) => {
    this.setState({ search: e.target.value }, () => {
      this.filterHandler(e);

    });
  };


  filterHandler = () => {
    let groupby = [...this.state.groupby];
    let temp = [];
    for (let i = 0; i < groupby.length; i++) {
      let content = groupby[i];

      if (content.information && content.information.label.toLowerCase().includes(this.state.search.toLowerCase())) {
        temp.push(content);
      }
    }
    this.setState({ characters: temp }, () => {
      this.state.search = "";
    });
  };
  selectHandler = (item) => {
    console.log('selectHandler', item)
    let defaultt = JSON.parse(JSON.stringify(this.state.default));
    // console.log('itemitem', item)
    defaultt.push(item);
    this.makeList(JSON.parse(JSON.stringify(defaultt)))
    this.setState({ default: defaultt }, () => {
      this.sortView.hideView()
    });
  };

  makeList = (defaultt) => {
    if (!defaultt) {
      defaultt = JSON.parse(JSON.stringify(this.state.default))
    }
    let characters = []
    this.props.headers.forEach(e => {
      if (!defaultt.includes(e)) {
        if (!characters.includes(e)) {
          characters.push(e)

        }
      }
    });

    console.log('makenewlist', defaultt)
    this.setState({ characters }, () => {
      this.props.functionsHandler(null, 'changeGroupBy', defaultt)
    })

  }


  crossHandler = (item) => {
    let arr = JSON.parse(JSON.stringify(this.state.default));
    let characters = JSON.parse(JSON.stringify(this.state.characters))
    arr = arr.filter((i) => (i.id != item.id || i.key != item.key));
    characters.push(item)
    this.setState({ default: arr, characters }, () => {
      console.log('defaultdefault', this.state.default)
      this.makeList()
    });
  };

  setData = (key, value) => {
    let defaultt = this.state.default
    for (let i = 0; i < defaultt.length; i++) {
      if (defaultt[i].id == key.id) {
        defaultt.splice(i, 1, value)
        break
      }
    }
    this.setState({ default: defaultt })

  }

  render() {
    return (
      <div className="w-100 " >


        {/* <div className='flexcb  position-sticky top-0 w-100' style={{ padding: '12px 14px', background: 'linear-gradient(90deg, #fff, #fff)', borderBottom: '1px solid #eee' }}>
          <div className='flexc'>
            <p className=' font-size-16 text-semibold'>{translate('Group By')}</p>
          </div>


          <LoaderButton
            onClick={this.saveStack}
            isLoading={this.state.isLoadingPost}
            text={translate('Submit')}
            // type={"Oval"}
            className={"text-bold text-small text-center flexcc w-100 br-20 py-1  "}
            background={this.props.colors?.background}
            width={20}
            height={20}
            color={this.props.colors?.textColor}
          />


        </div> */}



        <div className="flexc " style={{ flexDirection: "column", alignItems: "flex-start", backgroundColor: "#fff", width: "100%" }}>
          <DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <div className="" {...provided.droppableProps} ref={provided.innerRef} style={{ backgroundColor: "#fff" }}>
                  {this.state.default.map((item, index) => {
                    // console.log('defaultdefault', item)
                    return (
                      <>
                        <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>
                        <Draggable key={item.id ?? item.key} draggableId={item.id ?? item.key} index={index}>
                          {(provided, snapshot) => {
                            if (snapshot.isDragging) {
                              if (!provided.draggableProps) {
                                provided.draggableProps = { style: { boxShadow: "0px 0px 30px #10101090", zIndex: "999" } };
                              }
                              let bound = getBoundingClientRect(this.setPositionDiv.current);
                              const offset = { x: bound.left, y: bound.top };
                              // console.log(offset.x, offset.y)
                              const x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                              const y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                              // console.log("y:", y, "x:", x);
                              provided.draggableProps.style.left = x;
                              provided.draggableProps.style.top = y;
                              provided.draggableProps.style.boxShadow = "0px 0px 10px #10101020";
                              provided.draggableProps.style.zIndex = "999";
                            }
                            return (
                              <div className="sort flexc" ref={provided.innerRef} {...provided.draggableProps} >
                                <div className="w-100 flexc" style={{ backgroundColor: "#fff" }}>
                                  <div className="flexc " style={{ backgroundColor: "#fff" }}>
                                    {/* <div style={{ width: "15px" }}>
                                    {(item.information.label == "Priority" || item.information.label == "Flagged" || item.information.label == "Assignee") && (
                                      <img className="" style={{ opacity: 0.8 }} src="/assets/icons/eye.svg" width="13px" />
                                    )}
                                  </div> */}


                                    <div className="prd-1 flexcc" style={{ width: "15px" }} {...provided.dragHandleProps}>
                                      <img className="" style={{ opacity: 0.8 }} src="/assets/icons/drag-and-drop.svg" width="13px" />
                                    </div>

                                    <div className="br-20 flexcc" style={{ width: "15px", height: 15, backgroundColor: '#eee', border: '1px solid #eee' }} onClick={() => this.crossHandler(item)}>
                                      <img className="" style={{ opacity: 0.6, }} src="/assets/icons/close.svg" width="13px" />
                                    </div>

                                  </div>

                                  <FieldItem width={this.props.width} default={this.state.default} item={item} makeList={this.makeList} setData={this.setData} test={this.state.test} src={item.src} type={item.type} characters={this.state.characters} headers={this.props.headers} />
                                </div>
                              </div>
                            )
                          }}
                        </Draggable>
                      </>
                    );
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <div className="fields-buttons flexc  pt-1" ref={(el) => (this.currentNode = el)} style={{ width: "100%" }}>
          <button className="text-smaller flexc mb-1 px-1" onClick={() => this.openSortView()} style={{ color: '#007aff' }}>
            {/* <img className="" style={{ opacity: 0.8 }} src="/assets/icons/plus.svg" width="13px" /> */}
            <p className="text-smaller">+ {translate("Add Field to group")}</p>
          </button>
        </div>

        <FixedView ref={(el) => (this.sortView = el)} nodeRef={this.currentNode} showFocus={false} topOffset={0} xOffset={-10}>
          <div className='bg-white br-10 p-1 shadow-3 ' >
            <div className="w-100  sc-gray2" style={{ maxHeight: 350, overflowY: 'auto' }}>
              <div className="px-1">
                <div className=" flexc py-1 w-100 " >
                  {/* <img src="/assets/icons/gantt/search.svg" className="mld-1" /> */}
                  <input
                    type="search"
                    id="InputID"
                    name="name"
                    className='py-1 px-2 br-5 w-100' style={{ backgroundColor: '#F2F2F7', border: '1px solid #F2F2F7' }}
                    placeholder={translate("Find a field ...")}
                    value={this.state.search}
                    onChange={(e) => this.searchInput(e)}
                  />
                </div>
                {this.state.characters.map((item, index) => {
                  if (this.state.default.find((i) => (i.id == item.id || i.key == item.key))) {
                    return (
                      <></>
                    )
                  } else {
                    return (
                      <div className="flexc py-2 hover-gray br-5 " style={{ cursor: "pointer", width: "100%" }} onClick={() => this.selectHandler(item)}>
                        <img className="" style={{ opacity: 0.8 }} src={item.src} width="10px" />
                        <p className="text-smaller">{checkTranslation(item.information?.label)}</p>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </FixedView>
      </div>
    );
  }
}

export default GroupedBy;
